export const SET_TOKEN = 'SET_TOKEN' // 设置token
export const SET_USER_NAME = 'SET_USER_NAME' // 设置用户账号
export const SET_MEMBER_NUMBER = 'SET_MEMBER_NUMBER' // 设置会员编号
export const SET_USER_INFO = 'SET_USER_INFO' // 设置用户信息
export const SET_TRADING_PAIR = 'SET_TRADING_PAIR' // 设置选中的交易对
export const SET_TRADING_PAIR_DATA = 'SET_TRADING_PAIR_DATA' // 设置选中的交易对数据
export const SET_DOLLAREXHIBITION = 'SET_DOLLAREXHIBITION' // 设置美元展示
export const ADD_LOCAL_COLLECTION = 'ADD_LOCAL_COLLECTION' // 添加用户本地收藏的币种
export const DELETE_LOCAL_COLLECTION = 'DELETE_LOCAL_COLLECTION' // 删除用户本地收藏的币种
export const SET_COLLECTION_COIN = 'SET_COLLECTION_COIN' // 设置用户收藏的币种

export const ADD_KLINE_DATA = 'ADD_KLINE_DATA'
export const ADD_PLATE_DATA = 'ADD_PLATE_DATA'
export const ADD_REAL_DATA = 'ADD_REAL_DATA'
export const SET_CURRENT_SKIN = 'SET_CURRENT_SKIN' // 设置皮肤（交易中心页面）
export const SET_HANDICAP_FIRST_PRICE = 'SET_HANDICAP_FIRST_PRICE' // 设置盘口买入和卖出第一个价格
export const SET_CURRENT_HANDICAP = 'SET_CURRENT_HANDICAP' // 设置当前盘口
export const SET_BUYSELL_TOP = 'SET_BUYSELL_TOP' // 设置当前盘口距离顶部的距离

export const SET_INTERVAL = 'SET_INTERVAL'
export const SET_CONTROL_COIN = 'SET_CONTROL_COIN' // 设置币种名称排序
export const SET_CONTROL_PRICE = 'SET_CONTROL_PRICE' // 设置币种价格排序
export const SET_CONTROL_UPDOWN = 'SET_CONTROL_UPDOWN' // 设置币种涨幅排序

export const SET_HIDE_ASSETS_DATA = 'SET_HIDE_ASSETS_DATA' // 设置隐藏资产数据
export const SET_HIDE_ZERO_BALANCE = 'SET_HIDE_ZERO_BALANCE' // 设置隐藏零余额币种
export const SET_TRADING_PAIR_COINS_BALANCE = 'SET_TRADING_PAIR_COINS_BALANCE' // 设置交易对的两币种余额

// export const SET_READY_CENTER = 'SET_READY_CENTER' // 设置准备状态中心

export const SET_INDICATOR = 'SET_INDICATOR' // 设置指标

export const SET_QUOTE_DATA = 'SET_QUOTE_DATA' // 设置行情

export const CLEAR_KLINE_DATA = 'CLEAR_KLINE_DATA' // 清空K线数据
